import { render, staticRenderFns } from "./CustomInfo.vue?vue&type=template&id=765832c0&scoped=true"
import script from "./CustomInfo.vue?vue&type=script&lang=js"
export * from "./CustomInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomInfo.vue?vue&type=style&index=0&id=765832c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765832c0",
  null
  
)

export default component.exports